"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const styles_1 = require("@material-ui/core/styles");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const theme_1 = require("../../../styles/theme");
const common_1 = require("../../../utils/common");
const HEADER_FOOTER_HEIGHT = 166;
const DIALOG_TOP_MARGIN = 16;
const DIALOG_TOP_BOTTOM_PADDING = 12;
const TOP_MARGIN_MOBILE = 4;
/**
  DialogWrapper - wraps lazy loaded lists and has search functionality
  Different from DialogueWrapper which is used for Media Fields and Location Modals
*/
const modifiedBreakPoint = common_1.MOBILE_BREAKPOINT + 1;
const DialogWrapper = (props) => {
    const { open, onDone, onCancel, filterPlaceHolder, title, searchText, handleSearchText, loading, translateFunction = text => text } = props, moreProps = __rest(props, ["open", "onDone", "onCancel", "filterPlaceHolder", "title", "searchText", "handleSearchText", "loading", "translateFunction"]);
    const classes = useStyles({ onDone });
    const [localSearchText, setLocalSearchText] = (0, react_1.useState)(searchText);
    return (react_1.default.createElement(core_1.Dialog, { open: open, className: classes.dialog, onClose: onCancel, classes: { paperScrollPaper: classes.paperRoot } },
        react_1.default.createElement("div", { className: classes.dialogTitleBar },
            react_1.default.createElement("div", { className: classes.headerRoot },
                react_1.default.createElement(core_1.Typography, { className: classes.dialogTitle }, translateFunction(title)),
                react_1.default.createElement(core_1.IconButton, { onClick: onCancel, className: classes.closeRoot },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faClose, className: classes.closeIcon }))),
            react_1.default.createElement("div", { className: classes.searchBar },
                react_1.default.createElement(core_1.Input, { startAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(Search_1.default, { className: classes.searchIcon })), placeholder: translateFunction(filterPlaceHolder), className: classes.input, value: localSearchText, onChange: e => {
                        if (!loading) {
                            setLocalSearchText(e.target.value);
                            handleSearchText(e.target.value);
                        }
                    }, disableUnderline: true }))),
        react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { className: classes.dialogActions }, props.actions),
            props.children),
        react_1.default.createElement(core_1.Box, { className: classes.footer },
            react_1.default.createElement(core_1.Button, { className: classes.cancelbutton, onClick: onCancel }, translateFunction('Cancel')),
            onDone && (react_1.default.createElement(core_1.Button, { className: classes.footerDoneBtn, onClick: onDone }, translateFunction('Add'))))));
};
const useStyles = (0, styles_1.makeStyles)(theme => {
    const mobileBreakpoint = theme.breakpoints.down(modifiedBreakPoint);
    return {
        content: {
            height: `calc(100% - ${HEADER_FOOTER_HEIGHT}px - ${DIALOG_TOP_MARGIN}px)`,
            paddingLeft: 34,
            '&::-webkit-scrollbar': {
                width: 7,
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: 5,
                backgroundColor: theme_1.colors.scrollBar,
            },
            [mobileBreakpoint]: {
                height: `calc(100% - ${HEADER_FOOTER_HEIGHT}px - ${TOP_MARGIN_MOBILE}px)`,
                paddingLeft: 22,
            },
        },
        dialog: {
            "& [role='dialog']": {
                width: 650,
                maxWidth: 650,
                marginBottom: 0,
                height: `calc(95vh - ${DIALOG_TOP_MARGIN}px)`,
                maxHeight: '100%',
                marginTop: 0,
                overflow: 'hidden',
                padding: '6px 0px 6px 0px',
                [mobileBreakpoint]: {
                    height: `calc(100% - ${DIALOG_TOP_BOTTOM_PADDING}px)`,
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    borderRadius: 0,
                },
            },
        },
        dialogTitleBar: {
            color: theme_1.colors.white,
            padding: '18px 30px',
            borderBottom: `1px solid ${theme_1.colors.black10}`,
            [mobileBreakpoint]: {
                paddingInline: 22,
            },
        },
        dialogTitle: {
            fontSize: 19,
            fontWeight: 500,
            color: theme_1.colors.black,
            marginBottom: 14,
        },
        cancelbutton: {
            color: theme.palette.primary.main,
            width: 119,
            border: `1px solid ${theme.palette.primary.main}`,
            padding: '10px 35px',
            borderRadius: 5,
            textTransform: 'capitalize',
            fontFamily: 'Roboto',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            [mobileBreakpoint]: {
                width: '100%',
            },
        },
        footerDoneBtn: {
            display: 'flex',
            padding: '10px 36px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            lineHeight: 'normal',
            borderRadius: 5,
            background: theme.palette.primary.main,
            color: theme_1.colors.white,
            textTransform: 'capitalize',
            fontFamily: 'Roboto',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            width: 129,
            '&:hover': {
                background: theme.palette.primary.main,
            },
            [mobileBreakpoint]: {
                width: '100%',
            },
        },
        radioButtonSpacer: {
            width: '68px', //width of done button
        },
        dialogActions: {
            justifyContent: 'flex-start',
            color: theme.palette.primary.main,
            boxSizing: 'border-box',
            position: 'sticky',
            top: 0,
            padding: 0,
            cursor: 'pointer',
            padding: '22px 34px',
            paddingBottom: 0,
            paddingLeft: 0,
            paddingBottom: 9,
            [mobileBreakpoint]: {
                paddingRight: 22,
                paddingBottom: 9,
            },
        },
        searchBar: {
            height: 38,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: theme_1.colors.cultured7,
            color: theme.palette.grey[200],
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            borderRadius: 4,
            fontSize: 16,
            '& :before': {
                display: 'none',
                borderBottom: 0,
            },
        },
        searchIcon: {
            height: 22,
            width: 22,
            color: theme_1.colors.black35,
        },
        input: {
            padding: '8px 12px',
            '& .MuiInputBase-input': {
                padding: '2px 0px 1px 0px',
                fontSize: 14,
                fontWeight: 400,
                color: theme_1.colors.black0,
                [mobileBreakpoint]: {
                    fontSize: 16,
                },
                '&::placeholder': {
                    fontSize: 14,
                    fontWeight: 400,
                    color: theme_1.colors.black35,
                    opacity: 1,
                },
            },
        },
        paperRoot: {
            overflow: 'hidden',
        },
        footer: (props) => ({
            backgroundColor: theme_1.colors.white,
            display: 'flex',
            padding: '14px 30px',
            justifyContent: 'end',
            height: 39,
            zIndex: 2,
            gap: 14,
            boxShadow: `0px -2px 4px 0px ${theme_1.colors.black05}`,
            [mobileBreakpoint]: {
                justifyContent: props.onDone ? 'space-between' : 'end',
                padding: '14px 22px',
            },
        }),
        closeRoot: {
            width: 24,
            height: 24,
            position: 'absolute',
            right: 30,
            [mobileBreakpoint]: {
                right: 22,
            },
        },
        closeIcon: {
            fontSize: 20,
            color: theme_1.colors.black54,
        },
        headerRoot: {
            display: 'flex',
        },
    };
});
exports.default = DialogWrapper;
//# sourceMappingURL=DialogWrapperWeb.js.map